import React from 'react';
import { Platform } from 'react-native';
import { CustomNavigationHeader } from '@sg/garnish';
import { defineMessages, useIntl } from 'react-intl';
import { ScanToPayPalette } from '../../utils';

export const ScanToPayTabsHeader = (props: ScanToPayTabsHeaderProps) => {
  const { palette, onClose } = props;
  const { formatMessage } = useIntl();

  return (
    <CustomNavigationHeader.Container
      palette={palette}
      safeAreaEdges={Platform.OS === 'android' ? ['top'] : []}
    >
      <CustomNavigationHeader.Button.Right
        name="IconClose"
        palette={palette === 'cream' ? 'muted' : 'premium'}
        accessibilityLabel={formatMessage(messages.close)}
        onPress={onClose}
      />
    </CustomNavigationHeader.Container>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  close: {
    defaultMessage: 'Close',
    description: 'Scan To Pay | Header | Close',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayTabsHeaderProps = {
  palette: ScanToPayPalette;
  onClose: () => void;
};
